module.exports = __webpack_public_path__ + "static/media/fitbit-aria-air.1b385d5d.webp";